import classNames from 'classnames';
import React from 'react';
import { createUseStyles } from 'react-jss';
import tinycolor from 'tinycolor2';
import { useStorage } from '../hooks/use-storage';
import { useMenuManager } from '../utils/manager/menu-manager';
import { layoutDefaults } from '../utils/layout-defaults';

const animeteFromLeft =
  'animate__animated animate__fadeInLeft animate__delay-1s';

function Title({ value, className }) {
  const { menuLayout, menuInfo } = useStorage();
  const { getMenuTitleBackgroundUrl } = useMenuManager();
  const classes = useStyles({
    layout: menuLayout,
    info: menuInfo,
    getMenuTitleBackgroundUrl,
  });

  return (
    <div
      className={classNames(className, classes.container, animeteFromLeft)}
      style={{ '--animate-delay': '0.1s' }}
    >
      <span className={classes.titleText}>{value}</span>
    </div>
  );
}

const useStyles = createUseStyles({
  container: {
    verticalAlign: 'middle',
    marginLeft: layoutDefaults.smallestHorizontalMargin,
    // marginRight:
    //   layoutDefaults.bigHorizontalMargin -
    //   layoutDefaults.smallerHorizontalMargin,

    // border: '1px solid white',
  },
  titleText: {
    fontWeight: 'bolder',
    fontFamily: ({ layout }) => layout?.text?.title_font,
    fontSize: ({ layout }) => layout?.text?.title_font_size,
    textTransform: ({ layout }) => layout?.text?.title_font_style,
    color: ({ layout }) =>
      tinycolor(layout?.background?.container_color).darken(10).toHexString(),
    backgroundPosition: 'center',
    backgroundRepeat: 'no-repeat',
    backgroundSize: 'cover',
    padding: 10,

    // textShadow: ({ layout }) => `0 0 1px ${layout.text.default_color}`,

    backgroundImage: ({ getMenuTitleBackgroundUrl }) =>
      `url("${getMenuTitleBackgroundUrl()}")`,
  },
});

export { Title };
